import { useEffect } from 'react';
import { persistedQueryClient } from 'components/CacheableQueryClientProvider';

/**
 * Invalidates the auth user query so user data is re-fetched so checkout
 * sees current membership state rather than persisted cache.
 * No-op when the query is disabled (logged out).
 */
export const useRefreshAuthUserOnMount = (): void => {
  useEffect(() => {
    persistedQueryClient.invalidateQueries({ queryKey: ['auth-user'] });
  }, []);
};
